import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import SideBar from "../../components/Sidebar";
import useWindowWidth from "../../utils/windowWidth";

const ITutor = () => {
    const mainRef = useRef<HTMLHeadingElement>(null);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (
        localStorage.getItem("token") === null ||
        localStorage.getItem("token") === undefined
        ) {
        navigate("/login");
        }
        document.title = "I-Tutor - Nclude Portal";
    }, [navigate]);

    useEffect(() => {
        if (mainRef.current) {
        mainRef.current.focus();
        }
    }, [location]);

    const windowWidth = useWindowWidth();
    const isMobile = windowWidth < 769;
    const userNumber = localStorage.getItem("userPhoneNumber");
    const participantId = userNumber ? (userNumber.startsWith("+") ? userNumber : `+91${userNumber}`) : "+919876543210";
    return (
        <div className="containerr">
      {!isMobile && <Header />}
      <div className="page-container">
        <SideBar activePage="ITutor" />
        <main className="doc-container voice-agent-page" tabIndex={-1} id="main-content">
          <section className="landing-page" aria-labelledby="ITutor-heading">
            <h1 className="display-title" id="ITutor-heading" ref={mainRef} tabIndex={-1}>
              I-Tutor
            </h1>
            <div 
              className="content-container dashboard-container" 
              style={{ 
                height: "auto", 
                minHeight: "unset", 
                padding: isMobile ? "1.5rem 1rem" : "2rem 2rem",
                justifyContent: "center",
                marginTop: "1.5rem"
              }}
            >
                <h2 style={{ fontWeight: "600", textAlign: "center" }}>
                    Welcome to I-Tutor
                </h2>
                <p className="display-7" style={{ width: isMobile ? "90%" : "60%", margin: "1rem auto" }}>
                    I-Tutor is an AI-powered, voice-first tutor that teaches like a real classroom teacher with clear, structured, and interactive lessons. Designed for everyone, with a special focus on supporting blind and disabled learners.
                </p>
                <p
                    className="display-7"
                    style={{
                        width: isMobile ? "90%" : "60%",
                        margin: "1rem auto",
                        fontWeight: 500,
                    }}
                    >
                    <strong>Available content:</strong> CBSE Classes 6 to 12, Class 10 for UP State Board, Classes 9–12 for Rajasthan State Board, and Banking Exam preparation.
                </p>
              <div 
                className="agent-container" 
                style={{ 
                  marginTop: "1.5rem", 
                  width: "100%",
                  display: "flex",
                  justifyContent: "center"
                }}
              >
                <div
                   role="group"
                   aria-label="I-Tutor voice conversation controls"
                   style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "20px",
                    background: "rgba(255, 255, 255, 0.1)",
                    borderRadius: "12px",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    width: "fit-content"
                  }}
                >
                  <start-conversation-widget
                    agent-id="c46fa8c2-f910-49c2-b183-71cc6f48b6fa"
                    public-key="org_sec_xZQDkl6BMhH3Hr0jw8F5sPd6n7wyAoCS1lNwMYOsM6Y"
                    participant-id={participantId}
                    width={isMobile ? "240" : "320"}
                    height={isMobile ? "48" : "68"}
                    position="static"
                    mode="inline"
                    button-text="Start Learning"
                    title="Talk to I-Tutor"
                    description="Start learning with your AI voice tutor"
                    aria-label="Start a voice conversation with I-Tutor"
                    button-background="#1a1d2e"
                    button-text-color="#ffffff"
                    border-radius="8px"
                    show-waveform="true"
                    waveform-bar-count="8"
                    waveform-bar-color="#4b5563"
                    waveform-active-bar-color="#22D3EE"
                    waveform-height="28"
                    waveform-width="4"
                    waveform-animation-speed="50"
                  />
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    </div>
    )
}

export default ITutor;
